<template>
    <div class="info">
		
        <div class="title">
            <h1>{{ level }}考试报名表<span> / Registration Form for {{ level }} Examination </span></h1>
        </div>
        <el-form :model="enrollInfo" :rules="enrollRules" ref="enrollInfo" label-width="100px" label-position="left" @submit.native.prevent>
            <h2>基本信息</h2>
            <el-form-item label="姓名" prop="name">
                <el-input v-model="enrollInfo.name" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="英文姓名" prop="englishName">
                <el-input v-model="enrollInfo.englishName" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
                <el-radio-group v-model="enrollInfo.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                </el-radio-group>
            </el-form-item>
			<el-form-item label="所在地区" prop="nationId">
			    <el-select clearable v-model="enrollInfo.nationId" placeholder="请选择地区">
			        <el-option label="中国大陆" value=0></el-option>
					<el-option label="其他" value=-1></el-option>
			    </el-select>
			</el-form-item>
            <el-form-item v-if="enrollInfo.nationId==0" label="所在城市" prop="cityId">
                <el-cascader
                    :options="region"
                    v-model="city"
                    clearable
                    placeholder="请选择所在地区"
                    :props="{
                        'label':'name',
                        'value':'id',
                        'children':'children'
                    }"
                ></el-cascader>
                <!-- {{ enrollInfo.provinceId }} - {{ enrollInfo.cityId }} - {{ enrollInfo.ffff }} -->
            </el-form-item>
			<el-form-item v-else  label="详细地址" prop="address">
			    <el-input v-model="enrollInfo.address" placeholder="请输入详细地址"></el-input>
			    <!-- {{ enrollInfo.provinceId }} - {{ enrollInfo.cityId }} - {{ enrollInfo.ffff }} -->
			</el-form-item>
            <el-form-item label="证件类型" prop="certificateType">
                <el-select clearable v-model="enrollInfo.certificateType" placeholder="请选择证件类型">
                    <el-option
                        v-for="item in typeList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="证件号码" prop="certificateNumber">
                <el-input v-model="enrollInfo.certificateNumber" placeholder="请输入证件号码"></el-input>
            </el-form-item>
            <el-form-item label="证件上传" prop="certificatePhotoA" class="img">
                <upload-images
                    v-model="enrollInfo.certificatePhotoA"
                    :limit="1"
                    string>
                    <div class="mask">
                        <i class="el-icon-circle-plus-outline"></i>
                        请添加证件正面图片
                    </div>
                </upload-images>
                <upload-images
                    v-model="enrollInfo.certificatePhotoB"
                    :limit="1"
                    string>
                    <div class="mask">
                        <i class="el-icon-circle-plus-outline"></i>
                        请添加证件反面图片
                    </div>
                </upload-images>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
                <el-input v-model="enrollInfo.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="私人邮箱" prop="email">
                <el-input v-model="enrollInfo.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item label="QQ号码" prop="qq">
                <el-input v-model="enrollInfo.qq" placeholder="请输入QQ号码"></el-input>
            </el-form-item>
            <h2>证书邮寄地址</h2>
            <el-form-item label="收件人" prop="enrollReceiverVo.receiverName">
                <el-input v-model="enrollInfo.enrollReceiverVo.receiverName" placeholder="请输入收件人"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="enrollReceiverVo.receiverPhone">
                <el-input v-model="enrollInfo.enrollReceiverVo.receiverPhone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="收件地址" prop="enrollReceiverVo.address">
                <el-input v-model="enrollInfo.enrollReceiverVo.address" placeholder="请输入收件地址"></el-input>
            </el-form-item>
            <el-form-item prop="headImg" class="photo" label-width="0">
                <upload-images
                    v-model="enrollInfo.headImg"
                    :limit="1"
                    string>
                    <div class="mask">
                        <i class="el-icon-circle-plus-outline"></i>
                        点击上传照片
                    </div>
                </upload-images>
            </el-form-item>
        </el-form>
        <div class="buttons">
            <el-button @click="prev">返回上一步修改</el-button>
            <el-button :loading="submitLoading" @click="next(true)">保存进行下一步</el-button>
            <el-button :loading="saveLoading" @click="next(false)">暂存</el-button>
        </div>
    </div>
</template>

<script>
import { addrFilter } from '@/utils'
import uploadImages from '@/components/imageUpLoad'
import { listByType } from '@/api/cms'
import idcard from '@/utils/validTools'
import { scrollTo } from '@/utils/scrollTo'
import { enrollInfoDetail,enrollInfoAdd ,areaList,enrollInfoUpdate } from '@/api/enroll'
export default {
    name: 'info',
    components: {
        uploadImages
    },
    data(){
		let nameRules = (rule, value, callback) => {
			var reg = /^[A-Z][a-zA-Z]*,[A-Z][a-zA-Z]*$/;
		    if(reg.test(this.enrollInfo.englishName)||this.enrollInfo.certificateType!=1){
		        return callback()
		    }else{
		        return callback(new Error('请输入正确的英文名字格式,例如王某风，英文名为：“Wang,Moufeng”'))
		    }
		}
        let iiiiRules = (rule, value, callback) => {
            if(this.enrollInfo.certificatePhotoA && this.enrollInfo.certificatePhotoB){
                return callback()
            }else{
                return callback(new Error('请上传图片，格式为，jpg，png。不超过2M'))
            }
        }
        let headImgRules = (rule, value, callback) => {
            if(this.enrollInfo.headImg){
                return callback()
            }else{
                return callback(new Error('请上传图片，格式为，jpg，png。不超过2M'))
            }
        }
		let certRules = (rule, value, callback) => {
			if(this.enrollInfo.certificateType==1){
				idcard('idCard',value,callback,'请输入正确的身份证格式')
			}else{
				return callback()
			}
		}
        return {
            level: '',
			testurlid:'',
			cermuserid:'',
            submitLoading: false,
            saveLoading: false,
            typeList: [],
            region: [],
            enrollInfo: {
				peopleType:1,
				examType:'',
                name: this.$store.getters.userInfo.chineseName,
                englishName: '',
                sex: 1,
				nationId:"0",
				address:'',
                provinceId:'',
                cityId:'',
                certificateType: this.$store.getters.userInfo.documentType+'',
                certificateNumber: this.$store.getters.userInfo.documentNo,
                certificatePhotoA: '',
                certificatePhotoB: '',
                phone: this.$store.getters.userInfo.phone,
                email: this.$store.getters.userInfo.email,
                qq: '',
				enrollReceiverVo:{
					receiverName: '',
					receiverPhone: '',
					address: '',
				},
                headImg: '',
            },
            enrollRules: {
                name: [
                    { required: true, message: '请输入用户名/邮箱/手机号', trigger: 'blur' },
                ],
                sex: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
				nationId: [
				    { required: true, message: '请选择国家', trigger: 'change' }
				],
				cityId:[
                    { required: true, message: '请选择所在地区', trigger: 'change' }
                ],
                address: [
                    { required: true, message: '请输入所在地区', trigger: 'change' }
                ],
                certificateType: [
                    { required: true, message: '请选择证件类型', trigger: 'change' }
                ],
                certificateNumber: [
                    { required: true, validator: certRules },
                ],
                certificatePhotoA: [
                    { required: true, validator: iiiiRules },
                ],
                phone: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                ],
                // qq: [
                //     { required: true, message: '请输入QQ号码', trigger: 'blur' },
                // ],
				headImg: [
				    { required: true, validator: headImgRules },
				],
				englishName: [
				    { required: true, validator: nameRules },
				],
				enrollReceiverVo:{
					receiverName: [
					    { required: true, message: '请输入收件人', trigger: 'blur' },
					],
					receiverPhone: [
					    { required: true, message: '请输入电话', trigger: 'blur' },
					],
					address: [
					    { required: true, message: '请输入收件地址', trigger: 'blur' },
					],
				}
            },
        }
    },
    computed:{
        city:{
            get(){
                return [this.enrollInfo.provinceId, this.enrollInfo.cityId]
            },
            set(val){
                this.enrollInfo.provinceId = val[0]
                this.enrollInfo.cityId = val[1]
            },
        },
    },
    mounted(){
		listByType("IDENTIFY").then(res => {
			console.log(res)
			this.typeList = res
		})
		areaList({}).then(res=>{
			this.region=addrFilter(res)
		})
        this.$emit('changeIndex',3)
        this.level = this.$route.params.level
		this.enrollInfo.examType=this.$filters.testfilters(this.level)
		this.testurlid=this.$route.params.id
		if(this.testurlid){
			enrollInfoDetail({id:this.testurlid}).then(res=>{
				this.enrollInfo=res
				this.enrollInfo.nationId=this.enrollInfo.nationId+''
				this.enrollInfo.certificateType=this.enrollInfo.certificateType+''
			})
		}
        scrollTo(0,50)
    },
    methods:{
		changetype(){
			this.enrollInfo.peopleType==1?this.enrollInfo.peopleType=2:this.enrollInfo.peopleType=1
		},
        prev(){
            this.$router.replace(`/enroll/level/${this.level}`)
        },
        next(type){
            if(type){
                this.$refs['enrollInfo'].validate((valid) => {
                    if (valid){
						this.submitLoading = true
						if(this.testurlid){
							enrollInfoUpdate(this.enrollInfo).then(res => {
								this.submitLoading = false
								if(this.enrollInfo.peopleType==1){
									this.$router.push(`/enroll/education/${this.level}/${this.testurlid}`)
								}else{
									this.$router.push(`/enroll/societedu/${this.level}/${this.testurlid}`)
								}
							}).catch(()=>{
								this.submitLoading = false
							})
						}else{
							enrollInfoAdd(this.enrollInfo).then(res => {
								this.testurlid=res.msg
								this.submitLoading = false
								if(this.enrollInfo.peopleType==1){
									this.$router.push(`/enroll/education/${this.level}/${this.testurlid}`)
								}else{
									this.$router.push(`/enroll/societedu/${this.level}/${this.testurlid}`)
								}
							}).catch(()=>{
								this.submitLoading = false
							})
						}
                    }
                }) 
            }else{
                this.saveLoading = true
				if(this.testurlid){
					enrollInfoUpdate(this.enrollInfo).then(res => {
						this.saveLoading = false
					}).catch(()=>{
						this.saveLoading = false
					})
				}else{
					enrollInfoAdd(this.enrollInfo).then(res => {
						this.testurlid=res.msg
						this.saveLoading = false
						this.$router.push(`/enroll/info/${this.level}/${res.msg}`)
					}).catch(()=>{
						this.saveLoading = false
					})
				}
            }
            
            
        }
    },
    watch:{
        'enrollInfo.certificatePhotoA':function(val){
            this.$refs['enrollInfo'].validateField(['certificatePhotoA'])
        },
        'enrollInfo.certificatePhotoB':function(val){
            this.$refs['enrollInfo'].validateField(['certificatePhotoA'])
        },
        'enrollInfo.headImg':function(val){
            this.$refs['enrollInfo'].validateField(['headImg'])
        }
    }
}
</script>

<style scoped>
    @import './info.css';
    .info >>> .el-form{position: relative;}
    .photo{position: absolute;right: 200px;top: 56px;}
    .photo .upload{height: 207px;}
	.upload >>> .el-icon-circle-plus-outline{display: block!important;margin-top: 10px;}
    .photo .upload >>> .el-upload--picture-card{height: 207px;}
    .photo .upload >>> .mask i{padding-top: 74px;}
    .photo .upload >>> .el-upload-list__item{height: 207px;}
</style>
